<template>
  <v-flex v-if="disabled" class="text-center">
    <v-btn :dark="!hasRequested" :disabled="hasRequested" :color="plan.btnClass" v-if="!isCurrentPlan" @click="upgrade()">
      Upgrade
    </v-btn>
    <v-btn :disabled="true || hasRequested" v-else>
      Current plan
    </v-btn>
  </v-flex>
</template>

<script>
  export default {
    name: "icevergPlanForm",
    props: ['plan', 'currentPlan'],
    data: () => ({
      submitting: false
    }),
    computed: {
      disabled(){
        return this.currentPlan && this.currentPlan.id <= this.plan.id;
      },
      isCurrentPlan(){
        return this.currentPlan && this.currentPlan.id === this.plan.id;
      },
      hasRequested(){
        return this.currentPlan && this.currentPlan.requestedChangePlan !== undefined;
      },
      userData() {
        return this.$store.getters.getUserFromToken;
      }
    },
    methods: {
      cancel() {
        this.$emit('cancel');
      },
      upgrade() {
        this.submitting = true;
        const payload = {
          clientId: this.userData.clientId,
          userId: this.userData._id,
          plan: this.plan
        }
        this.$store.dispatch('changePlan', payload)
        .then(success => {
          this.submitting = false;
          if (success) {
            this.cancel();
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Forms/icevergPlanForm.vue